const WORKOUT_EXERCISE_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  NOTES: 'notes',
  ORDER: 'order',
  SET_DATA: 'setData',

  // Associations
  EXERCISE: 'exercise',

  // Foreign keys
  EXERCISE_ID: 'exerciseId',
  WORKOUT_SECTION_ID: 'workoutSectionId',
  WORKOUT_ID: 'workoutId',
  PROFILE_ID: 'profileId'

}

export { WORKOUT_EXERCISE_KEY }

const WORKOUT_EXERCISE_CLASS_NAME = 'WorkoutExercise'

export { WORKOUT_EXERCISE_CLASS_NAME }

const WORKOUT_EXERCISE_FOREIGN_KEYS = [
  WORKOUT_EXERCISE_KEY.EXERCISE_ID,
  WORKOUT_EXERCISE_KEY.WORKOUT_SECTION_ID
]

export const WORKOUT_EXERCISE_ASSOCIATION_KEYS = [
  WORKOUT_EXERCISE_KEY.EXERCISE
]

export { WORKOUT_EXERCISE_FOREIGN_KEYS }
// import { WORKOUT_EXERCISE_KEY } from './constants/workout-exercise/key'

const WORKOUT_EXERCISE_PRIVATE_KEYS = []

export { WORKOUT_EXERCISE_PRIVATE_KEYS }

const WORKOUT_EXERCISE_SCOPE = {

  /**
   * Only returns the public attributes of the Exercise.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: WORKOUT_EXERCISE_PRIVATE_KEYS
    }
  }

}

export { WORKOUT_EXERCISE_SCOPE }

export const WORKOUT_EXERCISE_ASSOCIATIONS = [
  WORKOUT_EXERCISE_KEY.EXERCISE
]

export const WORKOUT_EXERCISE_NON_SAVABLE_ASSOCIATIONS = [
  WORKOUT_EXERCISE_KEY.EXERCISE
]

export * from './set-data'
